import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/home/favicon.png'


const _hoisted_1 = { class: "auth-experience" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Sanvault", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<section class=\"auth-value-panel\"><div class=\"auth-value-panel__content\"><span class=\"auth-kicker\">Governança de gravações + inteligência operacional</span><h1>Suas conversas organizadas e prontas para trabalhar.</h1><p> Acesse as gravações da sua operação, acompanhe métricas e encontre rapidamente o contexto de cada chamada. </p><div class=\"auth-value-list\"><span><i class=\"ph ph-magnifying-glass\"></i> Busca pelo conteúdo falado</span><span><i class=\"ph ph-chart-line-up\"></i> Métricas claras da operação</span><span><i class=\"ph ph-shield-check\"></i> Histórico centralizado e protegido</span></div></div></section>", 1)
const _hoisted_5 = {
  class: "auth-form-panel auth-form-panel--login",
  "aria-label": "Acesso à plataforma"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "auth-brand",
      "aria-label": "Voltar para a página inicial da Sanvault"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_LoginForm)
    ])
  ]))
}